import React, { Fragment } from 'react'
import { Row, Col } from 'react-flexbox-grid'

import Button from 'components/Button'
import Divider from 'components/Divider'
import { Form, Text, Checkbox, Select, TextArea } from 'components/forms'
import { ContentBlock } from 'components/ContentBlock'
import listCategories from 'sections/category/gql/listCategories'
import { listSalesGroups, listShops } from 'gql/query'
import { notEmpty } from 'helpers/validators'
import { useTranslation } from 'react-i18next'

const Group = ({ data, formData = {}, appData, mutations: { updateItem, createItem }, newRecord }) => {
	const [t] = useTranslation()
	const isLinkFA = data?.FA_ProductId
	const handleSubmit = ({ category, ...restVals }) => {
		const mutationVals = {
			...restVals,
			...category && { categoryId: category.id },
			checkOutCommandId: '600'
		}
		return newRecord ? createItem(mutationVals) : updateItem(mutationVals)
	}

	return(
		<Form
			initialValues={formData}
			onSubmit={handleSubmit}
			smartSubmit={!newRecord}
			className='flex-col-container'
		>
			{({ formState, formApi }) => (
				<ContentBlock>
					<Row>
						<Col xs>
							<div>
								<Text
									field='code'
									label='Nummer'
									placeholder='Nummer eintragen'
									{...notEmpty()}
									disabled={isLinkFA}
									title='Artikel wird im FakturaAssist verwaltet'
									validateOnChange
									inline />
								<Checkbox
									inline={true}
									field='isActive'
									label='Aktiviert'
									disabled={isLinkFA}
									title='Artikel wird im FakturaAssist verwaltet' />
							</div>
							<Text
								label='Bezeichnung'
								field='name'
								placeholder='Bezeichnung eintragen'
								{...notEmpty()}
								disabled={isLinkFA}
								title='Artikel wird im FakturaAssist verwaltet'
								validateOnChange />
							<TextArea
								label='Alternative Artikelbezeichnung'
								field='altName'
								placeholder='' />
						</Col>
						<Col xs>
							<Select
								label='Schablone'
								field='category'
								valueField='id'
								labelField='name'
								withVirtualBody
								isSearchable
								remoteOptions={{ query: listCategories, variables: { params: { limit: 50 } } }}
								disabled={isLinkFA}
								simpleValue={false}
								title='Artikel wird im FakturaAssist verwaltet'
							/>
							<Select
								label='Unter Schablone'
								field='nestedCategoryId'
								valueField='id'
								labelField='name'
								withVirtualBody
								isSearchable
								remoteOptions={{ query: listCategories, variables: { params: { limit: 50 } } }}
							/>
							<Select
								remoteOptions={{ query: listSalesGroups }}
								label='Umsatzgruppe'
								field='salesGroupId'
								valueField='id'
								labelField='name'
								disabled={isLinkFA}
								title='Artikel wird im FakturaAssist verwaltet'
							/>
							{appData.isShopFieldActive &&
								<Select
									label={t('common.fields.shop_affiliation')}
									field='shopId'
									valueField='id'
									labelField='name'
									validate={val => !val && appData.shopAccess ? t('validators.required') : null}
									remoteOptions={{
										query: listShops,
										modifyOptions: (options => {
											return options
												.map(opt => opt.codePrefix ? ({ ...opt, name: `${opt.name} - "${opt.codePrefix}"` }) : opt)
										})
									}}
									isClearable={!appData.shopAccess}
								/>
							}
						</Col>
						{newRecord &&
							<Fragment>
								<Divider height={20}/>
								<Col type='row'>
									<Button type='submit' status='primary' text='erstellen'/>
								</Col>
							</Fragment>
						}
					</Row>
				</ContentBlock>
			)}
		</Form>
	)
}

export default Group
